import LoginModalTemplate from './login-modal'
import { InputsSubscribe } from './login-modal-subscribe/form/LoginModalSubscribeForm'

export { LoginModalTemplate }
export type { InputsSubscribe }
